const FEATURE_FLAG_NAMES = {
    OPTIONAL_TIPS_COPY_TREATMENT: 'driver-tips-optional-copy',
    REMOVE_EMAIL_FROM_LEAD: 'remove-email-from-lead',
    UP_SELLS_CAROUSEL_PLP: 'upsells-carousel-plp',
    UP_SELLS_CAROUSEL_PDP: 'upsells-carousel-pdp',
    PLUS_MEMBERSHIP: 'membership',
    MOBILE_PAYMENT_CTA: 'mobile-payment-cta',
    APPLE_PAY_CONFIGURATION: 'apple-pay-configuration',
    PREF_QUIZ_BACK_TEST: 'pref-quiz-back-test',
    KLARNA_CONFIGURATION: 'klarna-configuration',
};

const PREF_QUIZ_BACK_TEST_VARIANTS = {
    VARIANT_A: 'variant-a',
    VARIANT_B: 'variant-b',
    VARIANT_C: 'variant-c',
};

export { FEATURE_FLAG_NAMES, PREF_QUIZ_BACK_TEST_VARIANTS };
